'use client';

import { Session } from 'next-auth';

import { AuthProvider } from '@/app/api/auth/[...nextauth]/AuthProvider';
import { OAuthFallbackProvider } from '@/components/auth/oauth-fallback-provider';
import { ErrorBoundary } from '@/components/error-boundary';
import TriggerAnalytics from '@/components/firebase/TriggerAnalytics';
import Footer from '@/components/footer';
import { NavbarSafe } from '@/components/layout/navbar-safe';
import { SafeProviders } from '@/components/providers/SafeProviders';
import { UserStoreInitializer } from '@/components/providers/UserStoreInitializer';
import { Toaster } from '@/components/ui/toaster';
import { WebSocketProvider } from '@/providers/WebSocketProvider';
import { JSDebugger } from '@/components/debug/JSDebugger';
import { SessionDebugger } from '@/components/debug/SessionDebugger';

interface ClientLayoutProps {
  children: React.ReactNode;
  session: Session | null;
  userInfo: any;
}

export function ClientLayout({ children, session, userInfo }: ClientLayoutProps) {
  return (
    <AuthProvider session={session}>
      <OAuthFallbackProvider>
        <WebSocketProvider>
          <TriggerAnalytics />
          <UserStoreInitializer initialUser={userInfo} />
          <SafeProviders>
            <ErrorBoundary>
              <NavbarSafe />
              <main>{children}</main>
              <Footer />
            </ErrorBoundary>
          </SafeProviders>
          <Toaster />
          <JSDebugger />
          <SessionDebugger />
        </WebSocketProvider>
      </OAuthFallbackProvider>
    </AuthProvider>
  );
}